// src/com/tsr/TransPlanTsrEditSupplyGeneral.js
import React from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { TableContainer, Table, TableHead, TableBody, TableCell, TableRow } from '@mui/material';
import { AppWord, AppStyle } from '../../value/AppConst';
import VzmIntField from '../../common/VzmIntField';
import { InputTableCell } from '../../common/TopStyle';

const TitleCellBg = '#def';

const TitleCell = styled(TableCell)({
    backgroundColor: TitleCellBg,
    color: AppStyle.PrimaryRGB,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 2
});
const SubTitleCell = styled(TableCell)({
    backgroundColor: TitleCellBg,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 2
});

const DataDict = {
    aPalKpp: {id: 'aPalKpp', check: (value) => value >=0 && value <= 999999}, // Pallet KPP
    aPalAju: {id: 'aPalAju', check: (value) => value >=0 && value <= 999999}, // Pallet AJU
    aRollN: {id: 'aRollN', check: (value) => value >=0 && value <= 999999}, // Roll Cage 일반
    aRollJum: {id: 'aRollJum', check: (value) => value >=0 && value <= 999999}, // Roll Cage 점간대출
    aB2bKpp: {id: 'aB2bKpp', check: (value) => value >=0 && value <= 999999}, // B2B Pallet 일반
    aB2bAju: {id: 'aB2bAju', check: (value) => value >=0 && value <= 999999}, // B2B Pallet 점간대출
    aEtc: {id: 'aEtc', check: (value) => value >=0 && value <= 999999}, // 기타
    aOpSpec: {id: 'aOpSpec', check: (value) => value >=0 && value <= 999999}, // Other Pallet 특정
    aOpJum: {id: 'aOpJum', check: (value) => value >=0 && value <= 999999}, // Other Pallet 점간대출
    aOpTrunc: {id: 'aOpTrunc', check: (value) => value >=0 && value <= 999999}, // Other Pallet Trunking
    aHiDanpra: {id: 'aHiDanpra', check: (value) => value >=0 && value <= 999999}, // 고가상품 단프라
    aHiRoll: {id: 'aHiRoll', check: (value) => value >=0 && value <= 999999}, // 고가상품 롤케이지
    aTray: {id: 'aTray', check: (value) => value >=0 && value <= 999999}, // Tray
};

/**
 * 상온센터(안성ADC제외) 물류집기 편집
 * @param {*} param0 
 * @returns 
 */
export default function TransPlanTsrEditSupplyGeneral({
    item,
    onChangeValue
}) {

    return (
        <Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TitleCell colSpan={2} size={AppWord.SMALL}>Pallet</TitleCell>
                            <TitleCell colSpan={2} size={AppWord.SMALL}>Roll Cage</TitleCell>
                            <TitleCell colSpan={2} size={AppWord.SMALL}>B2B Pallet</TitleCell>
                        </TableRow>
                        <TableRow>
                            <SubTitleCell size={AppWord.SMALL}>KPP</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>AJU</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>일반</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>점간대출</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>KPP</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>AJU</SubTitleCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aPalKpp} value={item.aPalKpp}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aPalAju} value={item.aPalAju}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aRollN} value={item.aRollN}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aRollJum} value={item.aRollJum}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aB2bKpp} value={item.aB2bKpp}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aB2bAju} value={item.aB2bAju}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <Box style={{height:10}}></Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TitleCell colSpan={3} size={AppWord.SMALL}>Other Pallet</TitleCell>
                        </TableRow>
                        <TableRow>
                            <SubTitleCell size={AppWord.SMALL}>특정</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>점간대출</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>Trunking</SubTitleCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aOpSpec} value={item.aOpSpec}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aOpJum} value={item.aOpJum}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aOpTrunc} value={item.aOpTrunc}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <Box style={{height:10}}></Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TitleCell colSpan={2} size={AppWord.SMALL}>고가상품</TitleCell>
                            <TitleCell rowSpan={2} size={AppWord.SMALL}>기타</TitleCell>
                            <TitleCell rowSpan={2} size={AppWord.SMALL}>Tray</TitleCell>
                        </TableRow>
                        <TableRow>
                            <SubTitleCell size={AppWord.SMALL}>단프라</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>롤케이지</SubTitleCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aHiDanpra} value={item.aHiDanpra}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aHiRoll} value={item.aHiRoll}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aEtc} value={item.aEtc}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                            <InputTableCell>
                                <VzmIntField
                                    dict={DataDict.aTray} value={item.aTray}
                                    onChange={onChangeValue} fullWidth={true}
                                />
                            </InputTableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}